import { Modal } from 'antd';
import deleteItemDescription from '../../../Services/delete';

export default () => (dispatch) => {

  Modal.confirm({
    title: `Are you sure to delete this Item Description?`,
    content: 'Note: This action cannot be undone',
    okText: 'Yes, Delete it',
    width: 400,
    onOk: () => dispatch(deleteItemDescription())
  })

}